import { Component, Input, HostBinding } from '@angular/core';

declare function require(moduleName: string): any;

/* tslint:disable */
const {version: appVersion}: {version: string} = require("../../../../../../package.json");
/* tslint:enable */

@Component({
	selector: 'tacho-page-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

	@HostBinding('class.tacho-page-header') mainClass: boolean = true;

	@Input() logo: string = 'assets/images/VDO_logo.svg';

	public appVersion: string;

	constructor() {
		this.appVersion = appVersion;
	}
}
